import { cn } from 'lib/utils'
import * as React from 'react'

interface EyebrowProps {
  children: React.ReactNode
  /**
   * `default` is paper-dim (readable at 10px). `quiet` drops to paper-faint
   * for decorative eyebrows that intentionally recede (e.g. inside a card
   * already framed by a strong heading).
   *
   * `dim` kept as an alias for `default` for back-compat with existing
   * callsites — both resolve to paper-dim now.
   */
  tone?: 'default' | 'dim' | 'quiet'
  className?: string
}

/**
 * The mono-uppercase metadata label that sits above section headings, page
 * titles, and grouped content. Signature: `mono` + `text-[10px]` + `font-medium`
 * + `tracking-[0.18em]` + `uppercase` + `text-paper-dim`. See
 * playbook/design-system/components.md#eyebrow-label.
 */
export const Eyebrow: React.FC<EyebrowProps> = ({ children, tone = 'default', className }) => (
  <span
    className={cn(
      'mono text-[10px] font-medium tracking-[0.18em] uppercase',
      tone === 'quiet' ? 'text-paper-faint' : 'text-paper-dim',
      className
    )}
  >
    {children}
  </span>
)
